const assets = import.meta.glob("../assets/home/reveal-*.png", { eager: true, query: "?url", import: "default" });
export const revealMasks = Object.fromEntries(["organic", "soft", "grain"].map((mode) => [
  mode, Object.fromEntries(["top", "bottom", "both"].map((edge) => [
    edge, assets[`../assets/home/reveal-${mode}-${edge}.png`],
  ])),
]));
